// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { CotaUsuario } from "../interfaces/CotaUsuario";

export const atualizarCotaUsuarioService = async (
  id: number,
  data: Partial<CotaUsuario>
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota-usuario/${id}`;
    try {
      const response = await axios.put(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
